import styles from './option.less'; export {styles};
import CookieOption, {CookieOptionType} from '../../../cookieOption';
import Toggle from '../../../../../components/toggle';

interface OptionProps {
    option: CookieOption
}

interface OptionState {
    more: boolean;
}

export default class Option extends React.PureComponent<OptionProps, OptionState> {

    constructor(props) {
        super(props);

        this.state = {more: false};
    }

    render() {
        return (
            <div className={styles.option}>
                <div className={styles.head}>
                    <div className={styles.name}>{this.props.option.getName()}</div>
                    <div className={styles.actions}>
                        {this.props.option.getType() == CookieOptionType.TECHNICAL && (
                            <div className={styles.noaction}>{_('[COOKIES_MODAL] permanently on')}</div>
                        )}

                        {this.props.option.getType() != CookieOptionType.TECHNICAL && (
                            <Toggle
                                checked={this.props.option.isAllowed()}
                                onChange={(checked) => this.props.option.setAllowed(checked)}
                            />
                        )}
                    </div>
                </div>
                <div className={classNames(styles.description, {[styles.more]: this.state.more})}>
                    {this.props.option.getDescription()}
                    <div className={styles.readmore} onClick={() => this.setState({more: true})}>{_('[COOKIES_MODAL] ...read more')}</div>
                </div>
            </div>
        );
    }
}
